import { FC } from 'react';
import TextButton, { TextButtonProps } from '../../TextButton';
import { buttonEventHandler } from 'lib/utils/button-event-handler';

interface CarouselButtonProps {
  button: TextButtonProps;
  color: 'seedgreen' | 'snowwhite';
}

const CarouselButton: FC<CarouselButtonProps> = ({ button, color }) => {
  const handleClick = () => {
    buttonEventHandler(button.label ?? '', 'Product Carousel');
  };

  return (
    <TextButton
      id='carousel-button-link'
      label={button.label}
      url={button.url}
      underline={true}
      small={true}
      transform='lower'
      color={color === 'seedgreen' ? 'snowwhite' : 'seedgreen'}
      onClick={handleClick}
    />
  );
};

export default CarouselButton;
